import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}

export const VerifiedIcon: FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 16 17'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <g clipPath={'url(#clip0_8874_14126)'}>
        <path
          d={
            'M9.57372 2.76349L10.5341 4.25029L12.3037 4.33709L12.3933 6.10669L13.8801 7.06709L13.0737 8.64349L13.8801 10.2171L12.3933 11.1775L12.3065 12.9471L10.5369 13.0367L9.57652 14.5235L8.00012 13.7171L6.42652 14.5235L5.46612 13.0367L3.69652 12.9499L3.60692 11.1803L2.12012 10.2199L2.92652 8.64349L2.12012 7.06989L3.60692 6.10949L3.69372 4.33989L5.46332 4.25029L6.42372 2.76349L8.00012 3.56989L9.57372 2.76349Z'
          }
          fill={'#42A5F5'}
        />
        <path
          d={
            'M7.26935 10.6733L5.45215 8.85606L6.04575 8.26246L7.28055 9.49446L9.95735 6.89886L10.5425 7.50086L7.26935 10.6733Z'
          }
          fill={'white'}
        />
      </g>
      <defs>
        <clipPath id={'clip0_8874_14126'}>
          <rect fill={'white'} height={'16'} transform={'translate(0 0.643555)'} width={'16'} />
        </clipPath>
      </defs>
    </svg>
  )
}
